import { Segmentation } from 'constants/segmentation';
import { PetType } from 'constants/pet-type';

interface ShowPetProfileSelectorArgs {
  showPetSelector: boolean | Segmentation | undefined;
  featureFlag: boolean;
  petType: PetType;
  hasPetProfile: boolean;
}

/**
 * Defines whether we need to show PetProfileSelector or not
 */
export const showPetProfileSelector = ({
  showPetSelector,
  featureFlag,
  petType,
  hasPetProfile,
}: ShowPetProfileSelectorArgs): boolean => {
  const base = Boolean(showPetSelector) && featureFlag;

  // Deliberate asymmetry — cats need an existing profile, dogs don't.
  if (petType === PetType.Cat) return hasPetProfile && base;

  return base;
};
